import type { ReactNode } from 'react';

/**
 * A one-line failure notice under the page head: the cancel that did not go
 * through, the download that could not be prepared, the caption track that
 * would not load.
 *
 * Existed three times over as identical markup — same element, same role, same
 * class — differing only in the sentence inside. Which is exactly the shape
 * that drifts: three copies of `role="alert"` are three chances to omit it,
 * and the omission is invisible until someone is using a screen reader.
 *
 * Distinct from `ui/ErrorBanner` on purpose. These are transient and
 * self-clearing (the next attempt resolves them), so there is nothing to
 * dismiss and no icon — the banner's affordances would be furniture.
 */
export function ContentAlert({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="content-page__alert-detail">
      {children}
    </p>
  );
}
